import React, {useEffect, useState} from 'react';

import './App.css';

import Skin from "../Skin";
import {api} from "../../api/api";
import {ContractOptionMask, CheckOptionON} from "../../api/helper";
import Template from "../Template";
import LottieLoader from "../common/LottieLoader";
import {BuilderProvider} from '../../context/BuilderContext';
import {UserProvider} from '../../context/UserContext';
import {HotspotProvider} from '../../context/HotspotContext';
import {TranslationProvider, useTranslationDefs} from "../../context/TranslationContext";
import {testTemplate} from "./helpers";
import MetrikaPixel from "../Yandex";
import {AdModal} from '../Advertising';
import Plug from "../Plug";
import axios from "axios";
import HeaderApp from "../HeaderApp";
import { CrtAccessBanner } from '../../shared/CrtAccessBanner';
import { clearState, getState, storeState } from '../Authentication/AuthContainer/helpers';

const App = () => {
    const [data, setData] = useState({})
    const [dataFetch, setDataFetch] = useState(false)
    const [awaitHotspot, setAwaitHotspot] = useState(false)
    const [awaitApi, setApiWait] = useState(false)
    const {language, getTranslation, setLanguage, i18nIsLoad } = useTranslationDefs(document.documentElement.lang)

    const [adModalShow, setAdModalShow] = useState(false)
    const [adBreak, setAdBrake] = useState(false)
    const [unknown_device, setUnknownDevice] = useState(true)
    const [acceptRules, setAcceptRules] = useState(true)

    const [errState, setErrState] = useState(false)
    const [appError, setAppError] = useState({})
    useEffect(() => {
        document.documentElement.lang = language
    }, [language])

    useEffect(() => {
        const queryParams = window.location.href.split('?')[1]
        if (queryParams === undefined || !queryParams.toString().includes("nasid")) {
            return
        }

        async function loadData() {
            await api.getJson(queryParams).then(res => {
                if (res.status === 200) {
                    const data = {
                        ...res.data,
                    }
                    async function loadExternalApi() {
                        if (CheckOptionON(data.configuration, ContractOptionMask.AuthExternalAPI)) {
                            setApiWait(true)
                            await api.getExternalAuthMeta().then(res => {
                                data.external = res.data
                            }).catch(res => {
                                data.external = null
                                // console.log(res)
                            })
                            setApiWait(false)
                        } 
                    }
                
                    if (data.template) {
                        data.template.loader = testTemplate.loader
                    }
                    
                    if (data.reLogin) {
                        if (!data.err) {
                            setAwaitHotspot(true)
                            window.location.assign(data.reLogin.Pap)
                        }
                    }
                    loadExternalApi()
                    setData(data)
                    setUnknownDevice(CheckOptionON(data.configuration, ContractOptionMask.UnknownDevice),)
                    // localStorage.setItem("hotspot", JSON.stringify(res.data))
                    setDataFetch(true)
                }
            }).catch(res => {
                // console.log(res)
                if (axios.isCancel(res)) {
                    return
                }
                setAppError(res)
                setErrState(true)
                
            })
        }

        loadData()
    }, [])

    const builderData = () => {
        return {
            style: data.style,
            template: data.template,
            label: data.label,
            interactive: true,
            external: data.external,
            options: data.configuration
        }
    }

    const userData = () => {
        return {
            unknown_device: unknown_device,
            relogin: data.reLogin,
            setApiWait: setApiWait,
            error: data.err,
            acceptRules: acceptRules,
            setAcceptRules: setAcceptRules,
            setAdModalShow: setAdModalShow,
            setUnknownDevice: setUnknownDevice,
            adBreak: adBreak
        }
    }

    const hotspotData = () => {
        // console.log(data.request)
        if (data.request && getState("mac") !== data.request.Mac) {clearState()}
        if (data.request) {
            storeState("mac", data.request.Mac)
        }
        return {
            request: data.request,
            vendor: data.vendor,
            setAwaitHotspot: setAwaitHotspot
        }
    }
    if (errState) {
        let message = "Unknown error"
        if (appError.message.includes("Network")) {
            message = "Не удалось связаться с сервером. Повторите попытку подключения к сети WiFi"
            return <Plug message={message}/>
        }
        if (appError.message.includes("timeout")) {
            message = "Превышен интервал ожидания ответа"
            return <Plug message={message}/>
        }
        if (appError.response.status === 404) {
            message = "Ресурс не найден, обратитесь к менеджеру продаж в вашем регионе"
        }
        // console.log(appError.response)
        if (appError.response.status === 500) {
            message = "Сервис временно недоступен"
        }
        if (appError.response.status === 502) {
            message = "Проводятся работы. Повторите попытку позднее"
        }
        return <Plug message={message}/>
    }

    if (!dataFetch || !i18nIsLoad || awaitHotspot ) {
        return <LottieLoader label={"MF"} />
    }

    return (
        <HotspotProvider value={hotspotData()}>
            <BuilderProvider value={builderData()}>
                <UserProvider value={userData()}>
                    <TranslationProvider value={{
                        language,
                        getTranslation,
                        setLanguage,
                    }}>
                        {(awaitApi) && <LottieLoader label={data.style.loader} layer="top" />}
                        <MetrikaPixel account={55095736} />
                        {
                            adModalShow && <AdModal
                                setAuth={setAdBrake}
                                setEmptyFlag={setAdModalShow}
                            />
                        }
                        <div className="AppShell">
                            <CrtAccessBanner />
                            <div className="AppShellMain">
                                <HeaderApp/>
                                {
                                    data.template === undefined
                                        ? <Skin/>
                                        : <Template/>
                                }
                            </div>
                        </div>
                    </TranslationProvider>
                </UserProvider>
            </BuilderProvider>
        </HotspotProvider>

    );
}

export default App
